import { render, staticRenderFns } from "./addwiadvanceContact.vue?vue&type=template&id=e3631906&lang=pug"
import script from "./addwiadvanceContact.vue?vue&type=script&lang=js"
export * from "./addwiadvanceContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports